import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TrimSpacesDirective } from '@directives/trim-spaces.directive';

@Component({
    selector: 'app-reactive-field-input',
    templateUrl: './reactive-field-input.component.html',
    styleUrls: ['./reactive-field-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ReactiveFormsModule, TrimSpacesDirective]
})
export class ReactiveFieldInputComponent {
    label = input<string>();
    control = input.required<FormControl>();
    readonly = input<boolean>(false);
    placeholder = input<string>('');
    maxLength = input<number>(0);
    shouldTrimSpaces = input<boolean>(false);
}
